/**
 * API Errors page — standard error format and error types.
 */

import { createFileRoute } from "@tanstack/react-router";
import { DocsPage } from "@/components/docs/docs-page";
import { apiErrorsContent } from "@/constants/docs/api-errors";

export const Route = createFileRoute("/docs/api-errors")({
	component: ApiErrorsPage,
});

function ApiErrorsPage() {
	return <DocsPage title="Errors" content={apiErrorsContent} />;
}
